import { AppDispatch, RootState } from '..';
import { REACT_APP_AUTH_SERVICE_ENDPOINT, REACT_APP_COMPANY_SERVICE_ENDPOINT } from '../types';
import { companyUserType, registerFormTypes } from '../../types';
import { getUsersSuccess, onAddingUser, onLoadingUsers, onUpdatingPassword, onUpdatingUser } from '../reducers';

import axios from 'axios';
import { getUser } from './auth-actions';
import { notification } from '../../utils';

const headers = (token: string) => ({
    headers: {
        authorization: `Bearer ${token}`
    }
});

export const fetchUsers = () => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { data } = await axios.get(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/${company?.company_id}/users`, headers(token));

    try {

        const { users } = data;
        dispatch(getUsersSuccess(users));
        
    } catch (error) {
        console.log(error);
    }

};

export const updateUserRole = (id: string, values: companyUserType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onLoadingUsers(true));
    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_AUTH_SERVICE_ENDPOINT}/user/${id}/update`, { ...values }, headers(token));

    try {

        const { success, message } = data;

        dispatch(fetchUsers());
        notification(success ? 'success' : 'error', message);
        dispatch(onLoadingUsers(false));

    } catch (error) {
        const { message }: any = error;
        notification('error', message);
        dispatch(onLoadingUsers(false));
    }
};

export const addNewUser = (values: registerFormTypes) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    dispatch(onAddingUser(true));

    const { data } = await axios.post(`${REACT_APP_AUTH_SERVICE_ENDPOINT}/signup`, {...values}, headers(token));

    try {

        const { success, message } = data;
        notification(success ? 'success' : 'error', message);
        dispatch(onAddingUser(false));
        dispatch(fetchUsers());
    } catch (error) {
        const { message }: any = error;
        dispatch(onAddingUser(false));
        notification('error', message);
    }
};

export const updateUser = (id: string, values: registerFormTypes) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onUpdatingUser(true));

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_AUTH_SERVICE_ENDPOINT}/user/${id}/update`, {...values}, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(onUpdatingUser(false));
        dispatch(getUser());
        
    } catch (error: any) {

        notification('error', message || error.message);
        dispatch(onUpdatingUser(false));
        
    }
};

export const changeUserPassword = (id: string, values: registerFormTypes) => async (dispatch: AppDispatch, getState: RootState) => {
    
    dispatch(onUpdatingPassword(true));

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_AUTH_SERVICE_ENDPOINT}/user/${id}/update-password`, {...values}, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(onUpdatingPassword(false));
        
    } catch (error: any) {

        notification(success ? 'success' : 'error', message || error.message);
        dispatch(onUpdatingPassword(false));
        
    }
};

export const deleteUser = (id: string) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.delete(`${REACT_APP_AUTH_SERVICE_ENDPOINT}/user/${id}/delete`,  headers(token));

    const { success, message, error } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchUsers());
        
    } catch (err) {
        console.log(error || err);
        notification('error', message);
    }
};